import { baseState } from './state'

const mutations = {
  SET (state, roles = []) {
    state.roles = roles
  },

  SET_NEW (state, role) {
    if (!role.description) {
      role.description = ''
    }
    role.newName = role.name
    state.newRole = role
  },

  CLEAR_NEW (state) {
    let cleanRole = baseState().newRole
    Object.keys(cleanRole).forEach(key => {
      state.newRole[key] = cleanRole[key]
    })
    state.assignedPermissions = []
    state.selectedPermissions = []
  },

  SET_PERMISSIONS (state, permissions) {
    state.selectedPermissions = permissions
  },

  SET_ASSIGNED_PERMISSIONS (state, permissions) {
    state.assignedPermissions = permissions.slice()
  }
}

export default mutations
